<template>
    <div class="form">

        <WorkHistoryForm
            :states="states"
            :user="user"
            :countries="countries"
            @data-changed="updateForm"
        >
        </WorkHistoryForm>
        <div class="row">
            <div class="col-12 text-right ">
                <div class="wrap-border-top">
                    <div class="btns-wrap">
                        <a href="/application-step-5" class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                        <a href="javascript:void(0)" @click="save"
                           class="btn btn--secondary w-100 w-sm-auto">Continue</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import api from '@/js/services/api';
import WorkHistoryForm from "../CommonForms/WorkHistoryForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";


export default {
    name: "ApplicantFormStep6",
    components: {WorkHistoryForm},
    props: {
        user: {
            type: Object,
            required: true
        },
        states: {
            type: Array,
            required: true
        },
        countries: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dataFormStep6: [],
        }
    },
    methods: {
         async save() {
             try {
                 const response = await ApplicationFormService.saveStep6(this.dataFormStep6);
                 if (response.status === 200) {
                     this.$showSuccessMessage();
                     setTimeout(() => {
                         window.location.href = '/application-step-7';
                     }, 1000)
                 }
             } catch (error) {
                 this.$handleErrors(error)
             }
        },
        updateForm(dataWorkHistoryForm) {
            this.dataFormStep6 = dataWorkHistoryForm;
        }
    },

}

</script>

<style scoped>

</style>
